/**
 * @module geo/types/functionality
 */

/**
 * This type contains options for storing and managing functionalities
 *
 * To initialize application with functionality state :
 *
 * ```
 * var options = {
 *  functionalities: {
 *    name: "tourisme",
 *    startUp: true,
 *    parameters: {
 *      filters: [
 *        {
 *          name: "type",
 *          values: ["PATRIMOINE_NATUREL"]
 *        }
 *      ]
 *    }
 *  }
 * }
 * ```
 *
 */
export interface FunctionalityOptions  {
  /**
   * id of the functionality
   */
  id?: string;

  /**
   * name of functionality
   */
  name?: string;

  "@type"?: string;

  active?: boolean;

  visible?: boolean;

  parameters?: any;

  results?: any;

  startUp?: boolean;

  [key: string]: any;
}

/**
 * @private
 */
export abstract class FunctionalityType implements FunctionalityOptions {
  [key: string]: any;
  abstract "@type": string;
  abstract active?: boolean | undefined;
  abstract visible?: boolean | undefined;
  /**
   * catlog id of the functionality
   */
  abstract id: string;
  /**
   * name of the functionality
   */
  abstract name: string;

  protected _parameters: any;
  /**
   * return current parameters of the functionality, depend of it's type
   */
  public get parameters(): any {
    return this._parameters;
  }
  /**
   * @private
   * @param parameters
   */
  public set parameters(parameters: any) {
    this._parameters = parameters;
  }

  protected _results: any;

  /**
   * return current parameters of the functionality, depend of it's type
   */
  public get results(): any {
    return this._results;
  }

  /**
   * 
   */
  public set results(results: any) {
    this._results = results;
  }

  public get type(): string {
    return this["@type"];
  }
  constructor(options: FunctionalityOptions) {
    Object.assign(this, options);
    if (undefined === options["@type"]) {
      throw new Error("no @type in options");
    }
    this["@type"] = options["@type"];
  }
}

export interface FilterValue {
  /**
   * id of filter
   * @since v2.0.2
   */
  id?: string;
  /**
   * current name of filter
   * @since v2.0.1
   */
  name?: string;
  /**
   * attribute referencing this filter
   * @since v2.0.1
   */
  attribute?: string;
  /**
   * list of values for this filter
   * @since v2.0.1
   */
  value: string[];
}

/**
 * Selection to filter analyses or search
 */
export interface FeatureSelectionFilter {
  /**
   * type of spatial interaction , can be one value of
   * EQUALS,CONTAINED,CONTAINS,INTERSECTS
   * @type {string}
   */
  filter: string;
  features?: FeatureSelection[];
  /**
   * crs of the features Feature exemple: EPSG:3857
   */
  selectionCrs?: string;
}

/**
 * Context for filters
 */
export interface FilterContext {
  featureSelectionFilter?: FeatureSelectionFilter;
}

/**
 * Hashmap of functionalities, by id
 */
export interface IHashFunctionalities {
  [key: string]: FunctionalityOptions;
}

import { FilterValue, FilterContext, FunctionalityOptions } from ".";
import { FeatureSelection } from "../feature.selection";
